// ═══════════════════════════════════════════════════════════════════════════════
// Guard: require admin session for /hfs-admin/* app routes
// ═══════════════════════════════════════════════════════════════════════════════

import { Navigate, Outlet } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { adminPortalPath } from '../lib/adminPortalPaths';
import { getMaintenanceBreakGlassPath } from '../lib/maintenancePaths';

export const AdminProtectedRoute = () => {
  const { isAuthenticated, isLoading, admin } = useAdminAuth();
  const { t } = useLanguage();

  if (isLoading) {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-gray-950 text-gray-100"
        role="status"
        aria-label={t('common.loading')}
      >
        <p className="text-sm">{t('common.loading')}</p>
      </div>
    );
  }

  if (!isAuthenticated || !admin) {
    return <Navigate to={adminPortalPath('login')} replace />;
  }

  if (admin.breakGlassSession) {
    return <Navigate to={getMaintenanceBreakGlassPath()} replace />;
  }

  return <Outlet />;
};
